import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=063379b4&scoped=true&"
import script from "./StepHeader.vue?vue&type=script&lang=js&"
export * from "./StepHeader.vue?vue&type=script&lang=js&"
import style0 from "./StepHeader.vue?vue&type=style&index=0&id=063379b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063379b4",
  null
  
)

export default component.exports